// Based on https://gist.github.com/jwilson8767/db379026efcbd932f64382db4b02853e (MIT License, JWilson)

import { BeamError } from "./beam-errors";

export function waitForElement(selector: string, { timeout = 10000 } = {}): Promise<Element> {
  return new Promise((resolve, reject) => {
    let el = document.querySelector(selector);
    if (el) {
      resolve(el);
      return;
    }

    let mutationObserver: MutationObserver;

    const timer = setTimeout(() => {
      if (el) return; // no need to reject
      mutationObserver?.disconnect();
      reject(new BeamError(`Timed out waiting for '${selector}'`));
    }, timeout);

    new MutationObserver((_mutationRecords, observer) => {
      mutationObserver = observer;
      // Query for elements matching the specified selector
      Array.from(document.querySelectorAll(selector)).forEach((element) => {
        el = element;
        resolve(element);
        // Once we have resolved we don't need the observer anymore.
        observer.disconnect();
        clearTimeout(timer);
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}
